import React, { FC, ReactElement } from 'react'
import { Flex, Text, useTheme } from '@chakra-ui/react'
import { Button, Modal } from 'components/fromAdvisor/elements'
import { TrackLargeIcon } from 'components/fromAdvisor/elements/Icons'

export type ModalConfirmProps = {
  isOpen: boolean
  onClose: () => void
  onSubmit: () => void
  title: string
  textOK?: string
  textCancel?: string
  isKeepAll?: boolean
  isLoading?: boolean
}

/**
 * ModalConfirm component page.
 * @return {JSX.Element} ModalConfirm component.
 */
export const ModalConfirm: FC<ModalConfirmProps> = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  textOK = '削除する',
  textCancel = 'キャンセル',
  isKeepAll = false,
  isLoading = false,
}): ReactElement => {
  const theme = useTheme()
  return (
    <Modal isShowIconClose isOpen={isOpen} maxWidth={'360px'} onClose={onClose}>
      <Flex
        alignItems={'center'}
        flexDirection={'column'}
        gap={14}
        p={'72px 40px 56px 40px'}
      >
        <Flex alignItems={'center'} flexDirection={'column'} gap={2}>
          <TrackLargeIcon />
          <Flex
            color={'black.100'}
            flexDirection={'column'}
            fontSize={'xl'}
            fontWeight={'bold'}
            gap={1}
            lineHeight={theme.lineHeights['base']}
            textAlign={'center'}
            wordBreak={isKeepAll ? 'keep-all' : 'unset'}
          >
            {title.split('\n').map((line, index) => (
              <Text key={index}>{line}</Text>
            ))}
          </Flex>
        </Flex>

        <Flex flexDirection={'column'} gap={4} w={'full'}>
          <Button
            bg={'blue.900'}
            borderColor={'blue.900'}
            color={'white.50'}
            fontSize={'md'}
            fontWeight={700}
            h={12}
            isDisabled={isLoading}
            isLoading={isLoading}
            letterSpacing={'-0.02px'}
            lineHeight={'shorter'}
            text={textOK}
            w={'full'}
            onClick={onSubmit}
          />
          <Button
            borderColor={'blue.900'}
            color={'blue.900'}
            fontSize={'md'}
            fontWeight={700}
            h={12}
            isDisabled={isLoading}
            letterSpacing={'-0.02px'}
            lineHeight={'shorter'}
            text={textCancel}
            variant="outline"
            w={'full'}
            onClick={onClose}
          />
        </Flex>
      </Flex>
    </Modal>
  )
}
